<script setup lang="ts">
import { Download, Eye } from 'lucide-vue-next';
import { ref } from 'vue';

import DataTable from '~/components/shared/DataTable.vue';
import PreviewDocumentModal from '~/components/shared/PreviewDocumentModal.vue';
import Tooltip from '~/components/shared/Tooltip.vue';

import type { PartnerDocRow } from '../types';

withDefaults(defineProps<{
  documents?: PartnerDocRow[];
  loading?: boolean;
}>(), {
  documents: () => [],
  loading: false,
});

const TABLE_COLUMNS = [
  { key: 'label', label: 'Documento' },
];

const isPreviewVisible = ref(false);
const previewUrl = ref<null | string>(null);
const previewTitle = ref('Visualizar documento');

function downloadDocument(document: PartnerDocRow) {
  if (!document.url) return;
  window.open(document.url, '_blank');
}

function openDocumentPreview(document: PartnerDocRow) {
  if (!document.url_inline) return;
  previewUrl.value = document.url_inline;
  previewTitle.value = document.filename || document.label;
  isPreviewVisible.value = true;
}
</script>

<template>
  <div>
    <DataTable
      :columns="TABLE_COLUMNS"
      :data="documents"
      :loading="loading"
      :actions="[]"
      row-key="key"
      empty-message="Nenhum documento disponível"
    >
      <template #cell-label="{ item }">
        <span class="text-secondary">{{ (item as PartnerDocRow).label }}</span>
      </template>

      <template #extra-actions="{ item }">
        <Tooltip v-if="(item as PartnerDocRow).url_inline" content="Visualizar documento">
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            aria-label="Visualizar documento"
            @click="openDocumentPreview(item as PartnerDocRow)"
          >
            <Eye class="icon icon-sm" />
          </button>
        </Tooltip>
        <Tooltip v-if="(item as PartnerDocRow).url" content="Baixar documento">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            aria-label="Baixar documento"
            @click="downloadDocument(item as PartnerDocRow)"
          >
            <Download class="icon icon-sm" />
          </button>
        </Tooltip>
      </template>
    </DataTable>

    <PreviewDocumentModal
      v-model="isPreviewVisible"
      :title="previewTitle"
      :url="previewUrl"
    />
  </div>
</template>
